// This file is auto-generated by @hey-api/openapi-ts
import { createClient, createConfig, } from "./client";
export var client = createClient(createConfig({
    baseUrl: "http://localhost:7071",
}));
